<div *ngIf="shouldDisplay; else orgNotSelected">
  <nb-card size="large">
    <nb-tabset fullWidth (changeTab)="changeTab($event)">
      <nb-tab tabTitle="Transações">
        <div class="chart-container">
          <ngx-transactions-chart-summary [summary]="headerSummary"></ngx-transactions-chart-summary>
          <ngx-transactions-charts-header>
          </ngx-transactions-charts-header>
          <ngx-profit-chart #transactionsbarChart [chartData]="transactionsChartData"></ngx-profit-chart>
        </div>
      </nb-tab>
      <nb-tab tabTitle="Visão Alternativa" [lazyLoad]="true">
        <div class="chart-container">
          <ngx-transactions-chart-summary [summary]="headerSummary"></ngx-transactions-chart-summary>
          <ngx-transactions-charts-header>
          </ngx-transactions-charts-header>
          <ngx-transactions-line-chart #transactionsLineChart
            [transactionsLineChartData]="transactionsChartData"></ngx-transactions-line-chart>
        </div>
      </nb-tab>
    </nb-tabset>
  </nb-card>
</div>

<ng-template #orgNotSelected>
  <div class="row">
    <div class="col-md-12">
      <nb-card>
        <nb-card-body>
          <div class="flex-centered col-xl-4 col-lg-6 col-md-8 col-sm-12">
            <h3 class="title">Não há dados a serem exibidos.</h3>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</ng-template>